// File: src/config/role-based-navigation.ts
// Purpose: Role-based navigation configuration for InstaDev platform
// InstaDev - Role-Based Navigation

import { MenuItem } from '@/types/navigation'
import { UserRole } from '@/lib/rbac/roles'
import { store } from '@/store'

// Function to generate admin navigation based on isSuperAdmin flag from Redux store
export const getAdminNavigation = (): MenuItem[] => {
  // Get isSuperAdmin value directly from Redux store
  const isSuperAdmin = store.getState().auth.isSuperAdmin || false;

  return [
    {
      id: 'admin-dashboard',
      label: 'Admin Dashboard',
      icon: 'ShieldCheck',
      href: '/dashboard/admin/dashboard',
      children: [
        {
          id: 'platform-overview',
          label: 'Platform Overview',
          href: '/dashboard/admin/dashboard'
        },
        // {
        //   id: 'system-health',
        //   label: 'System Health',
        //   href: '/dashboard/admin/health'
        // },
        // {
        //   id: 'infrastructure',
        //   label: 'Infrastructure',
        //   href: '/dashboard/admin/infrastructure'
        // }
      ]
    },
    {
      id: 'user-management',
      label: 'User Management',
      icon: 'Users',
      children: [
        ...(isSuperAdmin ? [
          {
            id: 'all-employees',
            label: 'All Employees',
            href: '/dashboard/employees'
          },
          {
            id: 'users',
            label: 'Users',
            href: '/dashboard/users'
          }
        ] : []),
        {
          id: 'attendance',
          label: 'Attendance',
          href: '/dashboard/attendance'
        },

      ]
    },
    {
      id: 'project-management',
      label: 'Project Management',
      icon: 'FolderKanban',
      children: [
        ...(isSuperAdmin ? [
          {
            id: 'project-dashboard',
            label: 'Project Dashboard',
            href: '/dashboard/admin/project-dashboard'
          },
          {
            id: 'weekly-summary',
            label: 'Weekly Summary',
            href: '/dashboard/admin/weekly-summary'
          },
          {
            id: 'monthly-overview',
            label: 'Monthly Overview',
            href: '/dashboard/admin/monthly-overview'
          },
        ] : []),
        {
          id: 'timesheets',
          label: 'Timesheet Management',
          href: '/dashboard/admin/timesheets'
        },
        {
          id: 'project-tasks',
          label: 'Project Tasks',
          href: '/dashboard/admin/project-tasks'
        },
        {
          id: 'daily-tasks',
          label: 'Daily Tasks',
          href: '/dashboard/admin/daily-tasks'
        },

        {
          id: 'team-progress',
          label: 'Team Progress',
          href: '/dashboard/admin/team-progress'
        },
        
      ]
    },
    {
      id: 'ticket-management',
      label: 'Ticket Management',
      icon: 'Kanban',
      children:[
        // {
        //   id: 'jira-setup',
        //   label: 'JIRA Setup',
        //   href: '/dashboard/admin/jira-setup'
        // },
        {
          id: 'board',
          label: 'Board',
          href: '/dashboard/admin/board'
        },
        {
          id: 'sprint',
          label: 'Sprints',
          href: '/dashboard/admin/sprints'
        },
        {
          id: 'issue-types',
          label: 'Issue Types',
          href: '/dashboard/admin/issue-types'
        },
        // {
        //   id: 'workflows',
        //   label: 'Workflows',
        //   href: '/dashboard/admin/workflows'
        // },
      ]
    },
    {
      id: 'cost-management',
      label: 'Cost Management',
      icon: 'DollarSign',
      children: isSuperAdmin ? [
        // {
        //   id: 'employee-rates',
        //   label: 'Employee Rates',
        //   href: '/dashboard/admin/employee-rates'
        // },
        // {
        //   id: 'cost-tracking',
        //   label: 'Cost Tracking',
        //   href: '/dashboard/admin/cost-tracking'
        // },
        // {
        //   id: 'project-spending',
        //   label: 'Project Spending',
        //   href: '/dashboard/admin/project-spending'
        // },
        {
          id: 'import-export',
          label: 'Import/Export',
          href: '/dashboard/admin/import-export'
        }
      ] : [
        {
          id: 'import-export',
          label: 'Import/Export',
          href: '/dashboard/admin/import-export'
        }
      ]
    },
    {
      id: 'organization-management',
      label: 'Organization Management',
      icon: 'Building2',
      children: [
        {
          id: 'organizations',
          label: 'Organizations',
          href: '/dashboard/admin/organizations'
        },
        {
          id: 'llm-conversations',
          label: 'LLM Conversations',
          href: '/dashboard/admin/conversations'
        }
      ]
    },
    {
      id: 'ai-system',
      label: 'AI Management',
      icon: 'Building2',
      children: [
        {
          id: 'ai-chat',
          label: 'AI Assistant',
          href: '/dashboard/ai-chat'
        },
        {
          id: 'chat-system',
          label: 'Community Chat',
          href: '/dashboard/community-chat'
        }
      ]
    },
    // {
    //   id: 'analytics',
    //   label: 'Platform Analytics',
    //   icon: 'BarChart3',
    //   children: [
    //     {
    //       id: 'usage-analytics',
    //       label: 'Usage Analytics',
    //       href: '/dashboard/admin/analytics/usage'
    //     },
    //     {
    //       id: 'performance-metrics',
    //       label: 'Performance Metrics',
    //       href: '/dashboard/admin/analytics/performance'
    //     },
    //     {
    //       id: 'billing-analytics',
    //       label: 'Billing Analytics',
    //       href: '/dashboard/billing/analytics'
    //     }
    //   ]
    // },
    // {
    //   id: 'billing',
    //   label: 'Billing & Licenses',
    //   icon: 'CreditCard',
    //   children: [
    //     {
    //       id: 'billing-overview',
    //       label: 'Overview',
    //       href: '/dashboard/billing'
    //     },
    //     {
    //       id: 'usage',
    //       label: 'Usage',
    //       href: '/dashboard/billing/usage'
    //     },
    //     {
    //       id: 'licenses',
    //       label: 'Licenses',
    //       href: '/dashboard/admin/licenses'
    //     }
    //   ]
    // },
    // {
    //   id: 'system-config',
    //   label: 'System Configuration',
    //   icon: 'Settings',
    //   children: [
    //     {
    //       id: 'platform-config',
    //       label: 'Platform Configuration',
    //       href: '/dashboard/admin/config'
    //     },
    //     {
    //       id: 'integrations',
    //       label: 'System Integrations',
    //       href: '/dashboard/admin/integrations'
    //     },
    //     {
    //       id: 'monitoring',
    //       label: 'Monitoring',
    //       href: '/dashboard/admin/monitoring'
    //     }
    //   ]
    // }
  ]
}

// Admin navigation (Static version for backward compatibility)
export const adminNavigation: MenuItem[] = getAdminNavigation()

// Department Head navigation
export const departmentHeadNavigation: MenuItem[] = [
  {
    id: 'department-dashboard',
    label: 'Department Overview',
    icon: 'Building',
    href: '/departments'
  },
  {
    id: 'team-management',
    label: 'Team Management',
    icon: 'Users',
    children: [
      {
        id: 'team-members',
        label: 'Team Members',
        href: '/dashboard/team-members'
      },
      {
        id: 'employees',
        label: 'All Employees',
        href: '/dashboard/employees'
      },
      {
        id: 'team-performance',
        label: 'Team Performance',
        href: '/dashboard/analytics/team'
      }
    ]
  },
  {
    id: 'projects',
    label: 'Project Portfolio',
    icon: 'FolderKanban',
    children: [
      {
        id: 'all-projects',
        label: 'All Projects',
        href: '/dashboard/projects'
      },
      {
        id: 'project-analytics',
        label: 'Project Analytics',
        href: '/dashboard/analytics/projects'
      },
      {
        id: 'budget-management',
        label: 'Budget Management',
        href: '/dashboard/billing/budgets'
      }
    ]
  },
  {
    id: 'compliance',
    label: 'Compliance & Quality',
    icon: 'Shield',
    children: [
      {
        id: 'compliance-overview',
        label: 'Compliance Overview',
        href: '/dashboard/compliance'
      },
      {
        id: 'quality-standards',
        label: 'Quality Standards',
        href: '/dashboard/compliance/standards'
      },
      {
        id: 'audit-reports',
        label: 'Audit Reports',
        href: '/dashboard/compliance/audits'
      }
    ]
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      {
        id: 'department-settings',
        label: 'Department Settings',
        href: '/dashboard/settings/department'
      },
      {
        id: 'preferences',
        label: 'Preferences',
        href: '/dashboard/settings/preferences'
      }
    ]
  }
]

// Project Manager navigation
export const projectManagerNavigation: MenuItem[] = [
  {
    id: 'project-overview',
    label: 'Project Overview',
    icon: 'LayoutDashboard',
    href: '/dashboard/projects'
  },
  {
    id: 'projects',
    label: 'Project Management',
    icon: 'FolderKanban',
    children: [
      {
        id: 'my-projects',
        label: 'My Projects',
        href: '/dashboard/projects'
      },
      {
        id: 'new-project',
        label: 'Create Project',
        href: '/dashboard/projects/new'
      },
      {
        id: 'project-status',
        label: 'Project Status',
        href: '/dashboard/projects/status'
      }
    ]
  },
  {
    id: 'team-coordination',
    label: 'Team Coordination',
    icon: 'Users',
    children: [
      {
        id: 'team-members',
        label: 'Team Members',
        href: '/dashboard/team-members'
      },
      {
        id: 'task-management',
        label: 'Task Management',
        href: '/dashboard/tasks'
      },
      {
        id: 'assignments',
        label: 'Assignments',
        href: '/dashboard/assignments'
      }
    ]
  },
  {
    id: 'ai-orchestration',
    label: 'AI Orchestration',
    icon: 'Sparkles',
    children: [
      {
        id: 'ai-chat',
        label: 'AI Assistant',
        href: '/dashboard/ai-chat',
        badge: 'New'
      },
      {
        id: 'generation-hub',
        label: 'Generation Hub',
        href: '/dashboard/generation'
      },
      {
        id: 'custom-modes',
        label: 'Custom AI Modes',
        href: '/dashboard/ai-modes'
      }
    ]
  },
  {
    id: 'analytics',
    label: 'Project Analytics',
    icon: 'BarChart3',
    children: [
      {
        id: 'project-metrics',
        label: 'Project Metrics',
        href: '/dashboard/analytics/projects'
      },
      {
        id: 'team-performance',
        label: 'Team Performance',
        href: '/dashboard/analytics/team'
      }
    ]
  },
  {
    id: 'integrations',
    label: 'Integration Center',
    icon: 'Plug',
    href: '/dashboard/integration-center'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      {
        id: 'project-settings',
        label: 'Project Settings',
        href: '/dashboard/settings/project'
      },
      {
        id: 'preferences',
        label: 'Preferences',
        href: '/dashboard/settings/preferences'
      }
    ]
  }
]

// Team Lead navigation
export const teamLeadNavigation: MenuItem[] = [
  {
    id: 'team-overview',
    label: 'Team Overview',
    icon: 'LayoutDashboard',
    href: '/dashboard/team-members'
  },
  {
    id: 'development',
    label: 'Development',
    icon: 'Code',
    children: [
      {
        id: 'code-editor',
        label: 'Code Editor',
        href: '/dashboard/development/code-editor'
      },
      {
        id: 'version-control',
        label: 'Version Control',
        href: '/dashboard/development/version-control'
      },
      {
        id: 'review-queue',
        label: 'Review Queue',
        href: '/dashboard/review-queue',
        badge: '3'
      }
    ]
  },
  {
    id: 'ai-generation',
    label: 'AI Generation',
    icon: 'Sparkles',
    children: [
      {
        id: 'ai-chat',
        label: 'AI Assistant',
        href: '/dashboard/ai-chat'
      },
      {
        id: 'code-generation',
        label: 'Code Generation',
        href: '/dashboard/generation/code'
      },
      {
        id: 'architect-mode',
        label: 'Architect Mode',
        href: '/dashboard/ai-architect'
      }
    ]
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: 'FolderKanban',
    children: [
      {
        id: 'team-projects',
        label: 'Team Projects',
        href: '/dashboard/projects'
      },
      {
        id: 'project-status',
        label: 'Project Status',
        href: '/dashboard/projects/status'
      }
    ]
  },
  {
    id: 'team-management',
    label: 'Team Management',
    icon: 'UserCheck',
    children: [
      {
        id: 'team-members',
        label: 'Team Members',
        href: '/dashboard/team-members'
      },
      {
        id: 'team-tasks',
        label: 'Team Tasks',
        href: '/dashboard/tasks'
      },
      {
        id: 'sprint-planning',
        label: 'Sprint Planning',
        href: '/dashboard/sprints'
      },
      {
        id: 'team-performance',
        label: 'Team Performance',
        href: '/dashboard/analytics/team'
      }
    ]
  },
  {
    id: 'quality',
    label: 'Quality Assurance',
    icon: 'CheckSquare',
    children: [
      {
        id: 'testing',
        label: 'Testing',
        href: '/dashboard/development/testing'
      },
      {
        id: 'code-quality',
        label: 'Code Quality',
        href: '/dashboard/development/diagnostics'
      }
    ]
  }
]

// Developer navigation
export const developerNavigation: MenuItem[] = [
  {
    id: 'my-overview',
    label: 'My Overview',
    icon: 'LayoutDashboard',
    href: '/dashboard/projects'
  },
  {
    id: 'ai-generation',
    label: 'AI Generation',
    icon: 'Sparkles',
    children: [
      {
        id: 'ai-chat',
        label: 'AI Chat Assistant',
        href: '/dashboard/ai-chat',
        badge: 'New'
      },
      {
        id: 'new-generation',
        label: 'New Generation',
        href: '/dashboard/generation/new'
      },
      {
        id: 'code-generation',
        label: 'Code Generation',
        href: '/dashboard/generation/code'
      },
      {
        id: 'test-generation',
        label: 'Test Generation',
        href: '/dashboard/generation/tests'
      },
      {
        id: 'docs-generation',
        label: 'Documentation',
        href: '/dashboard/generation/docs'
      }
    ]
  },
  {
    id: 'development',
    label: 'Development',
    icon: 'Code',
    children: [
      {
        id: 'code-editor',
        label: 'Code Editor',
        href: '/dashboard/development/code-editor'
      },
      {
        id: 'scaffolding',
        label: 'Scaffolding',
        href: '/dashboard/development/scaffolding'
      },
      {
        id: 'version-control',
        label: 'Version Control',
        href: '/dashboard/development/version-control'
      },
      {
        id: 'testing',
        label: 'Testing',
        href: '/dashboard/development/testing'
      }
    ]
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: 'FolderKanban',
    children: [
      {
        id: 'my-projects',
        label: 'My Projects',
        href: '/dashboard/projects'
      },
      {
        id: 'project-status',
        label: 'Project Status',
        href: '/dashboard/projects/status'
      }
    ]
  },
  {
    id: 'tasks',
    label: 'Tasks',
    icon: 'CheckSquare',
    children: [
      {
        id: 'my-tasks',
        label: 'My Tasks',
        href: '/dashboard/tasks'
      },
      {
        id: 'assignments',
        label: 'Assignments',
        href: '/dashboard/assignments'
      }
    ]
  },
  {
    id: 'integrations',
    label: 'Integration Center',
    icon: 'Plug',
    href: '/dashboard/integration-center'
  },
  {
    id: 'analytics',
    label: 'My Analytics',
    icon: 'BarChart3',
    href: '/dashboard/analytics/personal'
  },
  {
    id: 'ai-history',
    label: 'AI Conversations',
    icon: 'MessageSquare',
    href: '/dashboard/my-ai-conversations'
  },
  {
    id: 'resources',
    label: 'Resources',
    icon: 'BookOpen',
    href: '/dashboard/resources/documentation'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    href: '/dashboard/settings/preferences'
  }
]

// QA Reviewer navigation
export const qaReviewerNavigation: MenuItem[] = [
  {
    id: 'qa-overview',
    label: 'QA Overview',
    icon: 'LayoutDashboard',
    href: '/dashboard/review-queue'
  },
  {
    id: 'review-queue',
    label: 'Review Queue',
    icon: 'CheckSquare',
    href: '/dashboard/review-queue',
    badge: '5'
  },
  {
    id: 'testing',
    label: 'Testing',
    icon: 'Bug',
    children: [
      {
        id: 'test-suites',
        label: 'Test Suites',
        href: '/dashboard/development/testing'
      },
      {
        id: 'test-creation',
        label: 'Create Tests',
        href: '/dashboard/generation/tests'
      },
      {
        id: 'diagnostics',
        label: 'Diagnostics',
        href: '/dashboard/development/diagnostics'
      }
    ]
  },
  {
    id: 'compliance',
    label: 'Compliance',
    icon: 'Shield',
    children: [
      {
        id: 'compliance-checks',
        label: 'Compliance Checks',
        href: '/dashboard/compliance'
      },
      {
        id: 'audit-trails',
        label: 'Audit Trails',
        href: '/dashboard/compliance/audits'
      },
      {
        id: 'quality-gates',
        label: 'Quality Gates',
        href: '/dashboard/compliance/quality-gates'
      }
    ]
  },
  {
    id: 'ai-assistant',
    label: 'AI Assistant',
    icon: 'Sparkles',
    children: [
      {
        id: 'review-mode',
        label: 'Review Mode',
        href: '/dashboard/ai-review'
      },
      {
        id: 'compliance-mode',
        label: 'Compliance Mode',
        href: '/dashboard/ai-compliance'
      }
    ]
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: 'FolderKanban',
    href: '/dashboard/projects'
  },
  {
    id: 'analytics',
    label: 'Quality Metrics',
    icon: 'BarChart3',
    children: [
      {
        id: 'quality-metrics',
        label: 'Quality Metrics',
        href: '/dashboard/analytics/quality'
      },
      {
        id: 'project-analytics',
        label: 'Project Analytics',
        href: '/dashboard/analytics/projects'
      }
    ]
  }
]

// Role-based navigation mapping
export const navigationByRole: Record<UserRole, MenuItem[]> = {
  [UserRole.SUPER_ADMIN]: adminNavigation,
  [UserRole.DEPARTMENT_HEAD]: departmentHeadNavigation,
  [UserRole.PROJECT_MANAGER]: projectManagerNavigation,
  [UserRole.TEAM_LEAD]: teamLeadNavigation,
  [UserRole.DEVELOPER]: developerNavigation,
  [UserRole.QA_REVIEWER]: qaReviewerNavigation,
  [UserRole.ADMIN]: adminNavigation,
}

// Helper function to get navigation for a user role
export function getNavigationForRole(role: UserRole): MenuItem[] {
  if (role === UserRole.SUPER_ADMIN || role === UserRole.ADMIN) {
    return getAdminNavigation()
  }
  return navigationByRole[role] || developerNavigation
}

// Helper function to check if user has access to a route
export function hasRouteAccess(role: UserRole, path: string): boolean {
  const navigation = getNavigationForRole(role)

  const checkAccess = (items: MenuItem[]): boolean => {
    for (const item of items) {
      if (item.href === path) return true
      if (item.children && checkAccess(item.children)) return true
    }
    return false
  }

  return checkAccess(navigation)
}